<template>
  <div
    class="rounded-extra-small flex-rounded bg-surface-container group relative flex grow cursor-pointer items-center gap-4 overflow-hidden px-4 py-2"
    @click="navigateToSurvey"
  >
    <div class="flex grow flex-row items-center">
      <div
        class="bg-primary-container text-on-primary-container mr-4 flex h-10 w-10 items-center justify-center rounded-full"
      >
        <BaseIcon size="24">{{ survey.feedbackTopic?.icon }}</BaseIcon>
      </div>
      <div class="flex flex-col">
        <h3 class="text-title-medium">
          {{ survey.title ?? survey.feedbackTopic?.title }}
        </h3>
        <span class="-mt-0.5">
          <CoachSurveyRecurringInformation
            class="text-on-surface-variant"
            :recurrence="survey.recurrence"
            :next-occurrence-at="survey.nextOccurrenceAt"
            :createdAt="survey.createdAt"
            :numberOfSurveys="survey.numberOfSurveys"
            :showNextOccurence="false"
            :showCreatedAt="false"
          />
        </span>
      </div>
    </div>

    <div v-if="survey.runningOccurrence" class="flex w-64 flex-col justify-end">
      <BaseLinearProgressIndictor :percentage="runningProgressPercentage" />
      <span class="text-body-medium text-on-surface-variant mt-0.5"
        >Aktuell: {{ survey.runningOccurrence.finishedSenders.length }}/{{
          survey.surveyTemplateMembers.length
        }}
        abgeschlossen</span
      >
    </div>
    <div class="flex w-32 flex-col">
      <BaseMemberAvatars
        class="bg-surface-container"
        :members="survey.surveyTemplateMembers"
        size="32"
        :displayLimit="5"
      />
      <span class="text-body-medium text-on-surface-variant mt-0.5"
        >{{ survey.surveyTemplateMembers.length }}
        {{ $t('common.coachees', survey.surveyTemplateMembers.length) }}</span
      >
    </div>
    <BaseIcon class="text-on-surface-variant shrink-0">chevron_right</BaseIcon>
    <BaseStateLayer />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRouter } from 'vue-router'
  import BaseMemberAvatars from '@/core/components/base/avatar/BaseMemberAvatars.vue'
  import BaseLinearProgressIndictor from '@/core/components/base/linear-progress-indicator/BaseLinearProgressIndictor.vue'
  import type { CoachSurveyPreview } from '../composables/use-coach-surveys'
  import CoachSurveyRecurringInformation from './CoachSurveyRecurringInformation.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'

  interface Props {
    survey: CoachSurveyPreview
  }

  const { survey } = defineProps<Props>()
  const router = useRouter()

  const navigateToSurvey = () => {
    router.push({ name: 'coach-survey', params: { id: survey.id } })
  }

  const runningProgressPercentage = computed(() => {
    if (!survey.runningOccurrence) {
      return 0
    }

    const finished = survey.runningOccurrence.finishedSenders.length
    const unfinished = survey.runningOccurrence.unfinishedSenders.length
    const total = finished + unfinished

    if (total === 0) {
      return 0
    }

    return Math.round((finished / total) * 100)
  })
</script>
